<!--Header-->
<div class="modal-header">
  <h6 class="modal-title pull-left">
    @if (modal_type === 'Add') {
    <h4>Add New User</h4>
    } @if (modal_type === 'Edit') {
    <h4>Edit User</h4>
    }
  </h6>
  <button
    type="button"
    class="btn-close float-right"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="closeModalClick()"
  ></button>
</div>

<!--body-->
<div class="modal-body">
  <form
    class="background"
    [formGroup]="add_edit_user_form"
    (ngSubmit)="onSubmit()"
  >
    <!-- First Name -->
    <div class="row my-1">
      <label
        for="name_first"
        class="col-sm-3 col-form-label col-form-label text-end"
        ><span style="color: red">*</span>First Name:</label
      >
      <div class="col-sm-5">
        <div class="form-group">
          <input
            type="text"
            class="form-control input"
            formControlName="name_first"
          />
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>
    <!-- Last Name -->
    <div class="row my-1">
      <label
        for="name_last"
        class="col-sm-3 col-form-label col-form-label text-end"
        ><span style="color: red">*</span>Last Name:</label
      >
      <div class="col-sm-5">
        <div class="form-group">
          <input
            type="text"
            class="form-control input"
            formControlName="name_last"
          />
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>
    <!-- Username -->
    <div class="row my-1">
      <label
        for="username"
        class="col-sm-3 col-form-label col-form-label text-end"
        ><span style="color: red">*</span>Username:</label
      >
      <div class="col-sm-5">
        <div class="form-group">
          <input
            type="text"
            class="form-control input"
            formControlName="username"
          />
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>
    <!-- Password -->
    <div class="row my-1">
      <label
        for="password"
        class="col-sm-3 col-form-label col-form-label text-end"
        ><span style="color: red">*</span>Password:</label
      >
      <div class="col-sm-5">
        <div class="form-group">
          <input
            type="password"
            class="form-control input"
            formControlName="password"
          />
          @if ( add_edit_user_form.value.password ===
          add_edit_user_form.value.password2 &&
          add_edit_user_form.value.password &&
          add_edit_user_form.value.password2 ) {
          <i
            class="fa-solid fa-circle-check icon_inside_input"
            style="color: green"
          ></i>
          } @if ( add_edit_user_form.value.password !==
          add_edit_user_form.value.password2 &&
          add_edit_user_form.value.password &&
          add_edit_user_form.value.password2 ) {
          <i
            class="fa-solid fa-circle-xmark icon_inside_input"
            style="color: red"
          ></i>

          }
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>
    <!-- Password2 -->
    <div class="row my-1">
      <label
        for="password2"
        class="col-sm-3 col-form-label col-form-label text-end"
        ><span style="color: red">*</span>Password:</label
      >
      <div class="col-sm-5">
        <div class="form-group">
          <input
            type="password"
            class="form-control input"
            formControlName="password2"
          />
          @if ( add_edit_user_form.value.password ===
          add_edit_user_form.value.password2 &&
          add_edit_user_form.value.password &&
          add_edit_user_form.value.password2 ) {
          <i
            class="fa-solid fa-circle-check icon_inside_input"
            style="color: green"
          ></i>
          } @if ( add_edit_user_form.value.password !==
          add_edit_user_form.value.password2 &&
          add_edit_user_form.value.password &&
          add_edit_user_form.value.password2 ) {
          <i
            class="fa-solid fa-circle-xmark icon_inside_input"
            style="color: red"
          ></i>
          }
        </div>
      </div>
      <div class="col-sm-3" style="text-align: left; color: red">
        @if ( add_edit_user_form.value.password !==
        add_edit_user_form.value.password2 && add_edit_user_form.value.password
        && add_edit_user_form.value.password2 ) {
        <span>Passwords don't match!</span>
        }
      </div>
    </div>
    <!-- Role -->
    <div class="row my-1">
      <label for="role" class="col-sm-3 col-form-label col-form-label text-end"
        ><span style="color: red">*</span>Role:</label
      >
      <div class="col-sm-5">
        <div class="form-group">
          <ng-select
            [items]="roles"
            [multiple]="false"
            [closeOnSelect]="true"
            appendTo="body"
            class="form-control text-uppercase input"
            formControlName="role"
          ></ng-select>
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>
    <div class="row my-1">
      <div class="col-sm-3" style="padding-left: 0px"></div>
      <div class="col-sm-5">
        <button
          class="btn btn-success"
          style="width: 100%"
          type="submit"
          [disabled]="
            !add_edit_user_form.valid ||
            !add_edit_user_form.dirty ||
            add_edit_user_form.value.password !==
              add_edit_user_form.value.password2
          "
        >
          Submit
        </button>
      </div>
      <div class="col-sm-4">
        <span style="color: red; display: inline-block">*</span> denotes
        required fields
      </div>
    </div>
  </form>
</div>
